import {AxiosResponse} from "axios";
import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {SimulateTriggerRequest, SimulateTriggerResponse} from "./types";

const simulateTrigger = async (payload: SimulateTriggerRequest): Promise<SimulateTriggerResponse> => {
  const response = await axiosReachInstance.post<
    SimulateTriggerResponse,
    AxiosResponse<SimulateTriggerResponse>,
    SimulateTriggerRequest
  >("/triggers/simulate", payload);
  return response.data;
};

export const useSimulateTrigger = (
  options?: BaseMutationOptions<SimulateTriggerResponse, SimulateTriggerRequest>
): BaseUseMutationResult<SimulateTriggerResponse, SimulateTriggerRequest> =>
  useBaseMutation<SimulateTriggerResponse, SimulateTriggerRequest>(simulateTrigger, options);
